import React, { useState } from 'react';
import './Sec6Form.css';
import axios from 'axios'; // Import Axios
import Cookies from 'js-cookie';

function Sec6Form() {
  const [email, setEmail] = useState('');

  const [formData, setFormData] = useState({
    email: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const searchParams = new URLSearchParams(window.location.search);
    const utm_source = (!(searchParams.get('utm_source'))?'na':searchParams.get('utm_source'));
    const utm_campaign = (!(searchParams.get('utm_campaign'))?'na':searchParams.get('utm_campaign'));
    const utm_medium = (!(searchParams.get('utm_medium'))?'na':searchParams.get('utm_medium'));
    const utm_term = (!(searchParams.get('utm_term'))?'na':searchParams.get('utm_term'));
    const utm_content = (!(searchParams.get('utm_content'))?'na':searchParams.get('utm_content'));
    const hubspotutkCookie = Cookies.get('hubspotutk');

    // Handle the subscription logic here
    // console.log(`Subscribed with email: ${email}`);

    var data = {
      "submittedAt": Date.now(),
      "fields": [
        {
          "objectTypeId": "0-1",
          "name": "email",
          "value": email
        },
        {
          "objectTypeId": "0-1",
          "name": "page_url",
          "value": window.location.href
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_campaign",
          "value": utm_campaign
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_content",
          "value": utm_content
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_medium",
          "value": utm_medium
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_source",
          "value": utm_source
        },
        {
          "objectTypeId": "0-1",
          "name": "utm_term",
          "value": utm_term
        }
      ],
      "context": {
            "hutk": hubspotutkCookie, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
            "pageUri": window.location.href,
            "pageName": document.getElementsByTagName("title")[0].innerHTML
       }
    }

    var final_data = JSON.stringify(data);

    axios.post('https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/subscribe_to_newsletter.php', final_data)
        .then(response => {
          // console.log('Subscribe to Newsletter  - Submit - Form data submitted:', response.data);
          //navigate('/women-speaker-details-listing',{state: {page: 'refresh'}});
        })
        .catch(error => {
          // console.error('Error submitting form data:', error);
        });
  };

  return (
    <div className="subscribe-container container">
      <h3 className="subscribe-title">Never miss a story</h3>
      <p className="subscribe-description">Stay updated about ZINNOV news as it happens</p>
      <form onSubmit={handleSubmit} className="subscribe-form">
        <input
          type="email"
          placeholder="Your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="subscribe-input"
          required
        />
        <button type="submit" className="subscribe-button">Subscribe</button>
      </form>
    </div>
  );
}

export default Sec6Form;
